import {AiOutlineInstagram} from 'react-icons/ai'
import {AiFillGithub} from 'react-icons/ai'
import {AiOutlineFacebook} from 'react-icons/ai'
import React from 'react'

const data = [
    {id: 1, link: 'https://www.instagram.com/dominic.digiacomo/', icon: <AiOutlineInstagram/>},
    {id: 2, link: 'https://github.com/sleepyitalian45', icon: <AiFillGithub/>},
    {id: 3, link: 'https://www.facebook.com/dominic.digiacomo.1/', icon: <AiOutlineFacebook/>},
]
export default data